import { render, staticRenderFns } from "./ModalMultiplesAmortizaciones.vue?vue&type=template&id=68235082&"
import script from "./ModalMultiplesAmortizaciones.vue?vue&type=script&lang=js&"
export * from "./ModalMultiplesAmortizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports